import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { DatabaseOutlined } from '@ant-design/icons';
import GoatAnimals from "./index";
import ViewGoat from "./view";
import EditGoat from "./edit";
import { MODULE_DA_GOAT } from "variables/constants";

const goatRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Goats",
		basePath: "animal-inventory/goats",
		mainComponent: <GoatAnimals />,
	    layout: "/console",
		icon: <DatabaseOutlined className="h-6 w-6" />,
	    subTitle:"Goat",
	    viewComponent: <ViewGoat />,
	    createComponent: <EditGoat />,
	    editComponent: <EditGoat />,
		moduleId: MODULE_DA_GOAT,
	})
]

export default goatRoutes;